/* global I18n, gon */
import React, { useContext } from 'react'
import { BundlesContext } from './BundlesProvider'
import PropTypes from 'prop-types'

import ReactTable from 'react-table'
import Trashcan from '../../../../assets/images/bundles/trash-var-solid25.png'

const ProductSelectionTable = ReactTable

const i18nOptions = {
  scope: 'turbosquid.products.bundles',
}

export default function BundlesProductSelection({ data }) {
  const {
    searchSelect,
  } = useContext(BundlesContext)

  const {
    handleAddToBundle,
  } = searchSelect

  const NameCell = ({ name, editorial }) => (
    <div>
      <span className="bundles-name-cell" >{name}</span>
      { editorial
        && <span className="editorial-table-cell"> {I18n.t('editorial_license', i18nOptions)}</span>}
    </div>
  )

  NameCell.propTypes = {
    status: PropTypes.string,
    editorial: PropTypes.bool,
  }

  NameCell.defaultProps = {
    status: '',
  }

  const renderNameCell = (cellInfo) => {
    /* eslint-disable */
    return (
      <NameCell
        name={cellInfo.original.name}
        editorial={cellInfo.original.license_id === 6}
      />
    )
    /* eslint-enable */
  }

  const renderPreviewCell = (cellInfo) => {
    /* eslint-disable */
    return (
      <div className="image-container bundles-image-container">
        <img className="bundles-image" src={cellInfo.original.thumbnail} alt={cellInfo.original.name} />
      </div>
    )
    /* eslint-enable */
  }

  const renderPriceCell = (cellInfo) => {
    /* eslint-disable */
    return (
      <span className='bundles-table-cell'>
        {cellInfo.original.price}
      </span>
    )
    /* eslint-enable */
  }

  const renderIdCell = (cellInfo) => {
    /* eslint-disable */
    return (
      <span className='bundles-table-cell'>
        {cellInfo.original.id}
      </span>
    )
    /* eslint-enable */
  }

  const renderRemoveCell = (cellInfo) => {
    /* eslint-disable */
    return (
      <span className="remove-container bundles-table-cell" data-testid="remove-bundle" onClick={(e) => {handleAddToBundle(cellInfo.original.id, 'remove')}}>
        <img className='remove-image' src={Trashcan} alt={'remove'}/>
      </span>
    )
    /* eslint-enable */
  }

  const defaultColumns = [
    {
      Header: 'Preview',
      maxWidth: 80,
      minWidth: 80,
      id: 'preview',
      accessor: 'thumbnail',
      Cell: renderPreviewCell,
    },
    {
      Header: 'Name',
      accessor: 'name',
      id: 'name',
      sortable: false,
      // minWidth: 80,
      Cell: renderNameCell,
    },
    {
      Header: 'Price',
      accessor: 'price',
      id: 'price',
      sortable: false,
      // minWidth: 80,
      Cell: renderPriceCell,
    },
    {
      Header: 'ID',
      accessor: 'id',
      id: 'id',
      sortable: false,
      // minWidth: 80,
      Cell: renderIdCell,
    },
    {
      Header: '',
      accessor: 'id',
      id: 'delete_id',
      sortable: false,
      // minWidth: 80,
      Cell: renderRemoveCell,
    },
  ]

  return (
    <>
      <div>
      <ProductSelectionTable
				manual
				data={data}
				columns={defaultColumns}
				keyField="name"
				NoDataComponent={() => null}
				showPagination={false}
				minRows={0}
      />
      </div>
    </>
  )
}
